import { AppState } from '@swarm/types/state'

export const selectInitiated = (state: AppState) => state.initiated
